import React from 'react'
import styled from 'styled-components'
import LazyLoad from 'react-lazyload'
import ProgressiveImage from 'react-progressive-image-loading'

const Img = styled.img`
  border-radius: 4px;
  background-color: #eaeaea;
  object-fit: cover;
  /* min-height: 320px; */
`

export default ({ width, height, alt, preview, src, lazyload }) =>
  lazyload ? (
    <LazyLoad height={height} once offset={200}>
      <figure className='image'>
        <noscript>
          <Img
            src={src}
            alt=''
            style={{
              maxWidth: width
            }}
          />
        </noscript>
        <ProgressiveImage
          preview={preview}
          src={src}
          render={(src, style) => (
            <Img
              src={src}
              alt=''
              style={{
                ...style,
                maxWidth: width
              }}
            />
          )}
        />
        <figcaption>{alt}</figcaption>
      </figure>
    </LazyLoad>
  ) : (
    <figure className='image'>
      <noscript>
        <Img
          src={src}
          alt=''
          style={{
            maxWidth: width
          }}
        />
      </noscript>
      <ProgressiveImage
        preview={preview}
        src={src}
        render={(src, style) => (
          <Img
            src={src}
            alt=''
            style={{
              ...style,
              maxWidth: width
            }}
          />
        )}
      />
      <figcaption>{alt}</figcaption>
    </figure>
  )
